let languageAll = {
    "zh": {
        "input_placeholder": "请填写",
        "select_year": "请选择出生年份",
        "select_month": "请选择出生月份",
        "select_date": "请选择出生日期",
        "select_year_month": "请选择出生年月",
        "select_city": "选择城市",
        "select": "请选择",
        "select_region": "请选择地区",
        "select_time": "请选择具体时间",
        "select_answer": "请选择答案",
        "end_wx": "该调查仅限微信答题，请更换答题设备",
        "end_pc": "该调查仅限电脑端答题，请更换答题设备",
        "end_phon": "该调查仅限手机端答题，请更换答题设备",
        "end": "结束页",
        "end_click": "点击抽奖",
        "end_no_answer": "请创建题目",
        "upload_file_qs": "题请上传",
        "upload_file_type": "格式的文件",
        "upload_file": "请上传",
        "upload_file_size": "M之内的文件",
        "upload_most": "最多只允许上传",
        "upload_file_number": "个文件",
        "age_up": "以上",
        "age_ups": "及以上",
        "age_down": "以下",
        "age_downs": "及以下",
        "age_range": "年龄段",
        "age_and": "及",
        "go_back": "返回上一题",
        "go_home_page": "返回首页",
        "last_page": "上一页",
        "next_page": "下一页",
        "submit": "提交",
        "restart": "重新开始",
        "modal_ok": "确认",
        "toast_msg": "请回答问题",
        "city_other": "其他",
        "sort_num": "请排序前",
        "toast_err": "系统错误，请联系管理员",
        "total": "总计",
        "phone_format_err": "请输入正确的手机号",
        "phone_verification_code_empty": "请填写验证码！",
        "phone_verification_code_err": "验证码错误！",
        "sms_send_success": "短信验证码已发送",
        "phone_input": "请输入手机号",
        "phone_verification_input": "请输入验证码",
        "phone_verification_send": "获取验证码",
        "second": "秒"
    },
    "zh_tw": {
        "input_placeholder": "請填寫",
        "select_year": "請選擇出生年份",
        "select_month": "請選擇出生月份",
        "select_date": "請選擇出生日期",
        "select_birthday": "請點擊此處選擇生日",
        "select_year_month": "請選擇出生年月",
        "select_city": "請選擇城市",
        "select": "請選擇",
        "select_region": "請選擇地區",
        "select_time": "請選擇具體時間",
        "select_answer": "請選擇答案",
        "end_wx": "該調查僅限微信答題，請更換答題設備",
        "end_pc": "該調查僅限電腦端答題，請更換答題設備",
        "end_phon": "該調查僅限手機端答題，請更換答題設備",
        "end": "結束頁",
        "end_thanks": "謝謝您的參與",
        "end_click": "點擊抽獎",
        "end_no_answer": "請提供具體的題目內容",
        "upload_file_qs": "請上傳",
        "upload_file_type": "格式的文件",
        "upload_file": "請上傳不超過",
        "upload_file_size": "MB的文件",
        "upload_most": "最多只允許上傳",
        "upload_file_number": "個文件",
        "age_up": "歲以上",
        "age_ups": "歲及以上",
        "age_down": "歲以下",
        "age_downs": "歲及以下",
        "age_range": "年齡段",
        "go_back": "回到上一题",
        "go_home_page": "返回首页",
        "last_page": "上一页",
        "next_page": "下一页",
        "submit": "提交",
        "restart": "重新开始",
        "modal_ok": "確認",
        "toast_msg": "請完整回答此題",
        "city_other": "其他",
        "sort_num": "請排序前",
        "toast_err": "系統錯誤，請聯繫管理員",
        "total": "總計",
        "phone_format_err": "請輸入正確的手機號碼",
        "phone_verification_code_empty": "請填寫驗證碼！",
        "phone_verification_code_err": "驗證碼錯誤！",
        "sms_send_success": "簡訊驗證碼已發送",
        "phone_input": "請輸入手機號碼",
        "phone_verification_input": "請輸入驗證碼",
        "phone_verification_send": "獲取驗證碼",
        "second": "秒"

    },
    "en": {
        "input_placeholder": "Please fill in",
        "select_year": "Please select your birth year",
        "select_month": "Please select your birth month",
        "select_date": "Please select your birth date",
        "select_birthday": "Please click here to select your birthday",
        "select_year_month": "Please select your birth year and month",
        "select_city": "Please select city",
        "select": "Please select",
        "select_region": "Please select region",
        "select_time": "Please select specific time",
        "select_answer": "Please select an answer",
        "end_wx": "This survey is only available for WeChat answering. Please switch to a different answering device",
        "end_pc": "This survey is only available for computer answering. Please switch to a different answering device",
        "end_phon": "This survey is only available for mobile phone answering. Please switch to a different answering device",
        "end": "End page",
        "end_thanks": "Thank you for your participation",
        "end_click": "Click to enter the lottery",
        "end_no_answer": "Please create a question",
        "upload_file_qs": "Please upload the file in ",
        "upload_file_type": "format",
        "upload_file": "Please upload a file below",
        "upload_file_size": " in size",
        "upload_most": "Please limit the file upload to a maximum of ",
        "upload_file_number": "files",
        "age_up": "years old",
        "age_ups": "years old and above",
        "age_down": "years old",
        "age_downs": "years old and below",
        "age_range": "Age group",
        "go_back": "Previous question",
        "go_home_page": "Home page",
        "last_page": "上一页",
        "next_page": "下一页",
        "submit": "提交",
        "restart": "重新开始",
        "modal_ok": "Confirm",
        "toast_msg": "Please answer the question ",
        "city_other": "其他",
        "sort_num": "Please sort the top",
        "toast_err": "System error, please contact the administrator",
        "total": "Total",
        "phone_format_err": "Please enter the correct phone number",
        "phone_verification_code_empty": "Please fill in the verification code!",
        "phone_verification_code_err": "The verification code is incorrect!",
        "sms_send_success": "SMS verification code has been sent",
        "phone_input": "Please enter your phone number",
        "phone_verification_input": "Verification code",
        "phone_verification_send": "Get verification code",
        "second": "seconds"
    },
    "jap": {
        "input_placeholder": "入力してください",
        "select_year": "生年を選択してください",
        "select_month": "生まれた月を選択してください",
        "select_date": "生まれた日を選択してください",
        "select_birthday": "ここをクリックして誕生日を選択してください",
        "select_year_month": "生年月を選択してください",
        "select_city": "都市を選択してください",
        "select": "選択してください",
        "select_region": "地域を選択してください",
        "select_time": "具体的な時間を選択してください",
        "select_answer": "答えを選択してください",
        "end_wx": "この調査はWeChatでの回答のみ可能です。別の回答デバイスに切り替えてください",
        "end_pc": "この調査はコンピュータ上での回答のみ可能です。別の回答デバイスに切り替えてください",
        "end_phon": "この調査は携帯電話上での回答のみ可能です。別の回答デバイスに切り替えてください",
        "end": "終了ページ",
        "end_thanks": "ご参加いただきありがとうございます",
        "end_click": "抽選をクリックしてください",
        "end_no_answer": "問題を作成してください",
        "upload_file_qs": "题请上传",
        "upload_file_type": "格式的文件",
        "upload_file": "请上传",
        "upload_file_size": "M之内的文件",
        "upload_most": "最多只允许上传",
        "upload_file_number": "个文件",
        "age_up": "歳以上",
        "age_ups": "歳と",
        "age_down": "歳未満",
        "age_downs": "歳と",
        "age_range": "年齢層",
        "go_back": "前の質問に戻る",
        "go_home_page": "ホームに戻る",
        "last_page": "上一页",
        "next_page": "下一页",
        "submit": "提交",
        "restart": "重新开始",
        "modal_ok": "確認する",
        "toast_msg": "未回答の設問があります",
        "city_other": "其他",
        "sort_num": "つをソートしてください",
        "toast_err": "システムエラーが発生しました。管理者に連絡してください",
        "total": "合計",
        "phone_format_err": "正しい電話番号を入力してください",
        "phone_verification_code_empty": "認証コードを入力してください！",
        "phone_verification_code_err": "認証コードが間違っています！",
        "sms_send_success": "SMS認証コードを送信しました",
        "phone_input": "電話番号を入力してください",
        "phone_verification_input": "認証コード",
        "phone_verification_send": "認証コードを取得してください",
        "second": "秒"
    }
}
let info = languageAll[sessionStorage.getItem("internationalizeFlag") || "zh"];
// info =languageAll["jap"];


let language2 = {
    "input_placeholder": info["input_placeholder"],
    "select_year": info["select_year"],
    "select_month": info["select_month"],
    "select_date": info["select_date"],
    "select_year_month": info["select_year_month"],
    "select_city": info["select_city"],
    "select": info["select"],
    "select_region": info["select_region"],
    "select_time": info["select_time"],
    "select_answer": info["select_answer"],
    "end_wx": info["end_wx"],
    "end_pc": info["end_pc"],
    "end_phon": info["end_phon"],
    "end": info["end"],
    "end_click": info["end_click"],
    "end_no_answer": info["end_no_answer"],
    "upload_file_qs": info["upload_file_qs"],
    "upload_file_type": info["upload_file_type"],
    "upload_file": info["upload_file"],
    "upload_file_size": info["upload_file_size"],
    "upload_most": info["upload_most"],
    "upload_file_number": info["upload_file_number"],
    "age_up": info["age_up"],
    "age_ups": info["age_ups"],
    "age_down": info["age_down"],
    "age_downs": info["age_downs"],
    "age_range": info["age_range"],
    "age_and": info["age_and"],
    "go_back": info["go_back"],
    "go_home_page": info["go_home_page"],
    "last_page": info["last_page"],
    "next_page": info["next_page"],
    "submit": info["submit"],
    "restart": info["restart"],
    "modal_ok": info["modal_ok"],
    "toast_msg": info["toast_msg"],
    "city_other": info["city_other"],
    "sort_num": info["sort_num"],
    "toast_err": info["toast_err"],
    "total": info["total"],
    "phone_format_err": info["phone_format_err"],
    "sms_send_success": info["sms_send_success"],
    "phone_input": info["phone_input"],
    "phone_verification_input": info["phone_verification_input"],
    "phone_verification_send": info["phone_verification_send"],
    "phone_verification_code_err": info["phone_verification_code_err"],
    "phone_verification_code_empty":info["phone_verification_code_empty"]
}

function language(key) {
    let info = languageAll[sessionStorage.getItem("internationalizeFlag") || "zh"];
    return info
}

// language
export {language,}